"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ColorPicker", {
  enumerable: true,
  get: function get() {
    return _ColorPicker["default"];
  }
});
var _ColorPicker = _interopRequireDefault(require("./ColorPicker"));